import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  ViewChild,
} from "@angular/core";
import { OwlOptions, CarouselComponent } from "ngx-owl-carousel-o";

@Component({
  selector: "app-bize-guvenenler-owl",
  templateUrl: "./bize-guvenenler-owl.component.html",
  styleUrls: ["./bize-guvenenler-owl.component.scss"],
})
export class BizeGuvenenlerOwlComponent implements AfterViewInit, OnDestroy {
  @Input() data: string[] = [];
  @Input() startInitial = false;

  bizeGuvenenlerOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    navSpeed: 4000,
    navText: ["", ""],
    responsive: {
      0: { items: 2 },
      520: { items: 3 },
      768: { items: 4 },
    },
    nav: false,
    autoplay: false,
    slideTransition: "linear",
  };
  startedBefore = false;

  @ViewChild("bizeGuvenenlerCarousel")
  bizeGuvenenlerCarousel: CarouselComponent;

  private autoplayTimeout: any = null;
  private autoplayInterval: any = null;
  private autoplayEnabled = false;
  private observer?: IntersectionObserver;

  constructor(private hostRef: ElementRef<HTMLElement>) {}

  ngAfterViewInit(): void {
    const itemsWrapper = this.hostRef.nativeElement.querySelector(
      ".bize-guvenenler-items-wrapper"
    );
    if (!itemsWrapper) return;

    this.observer = new IntersectionObserver(
      ([entry]) => this.onVisibilityChange(entry.isIntersecting),
      { threshold: 0 }
    );
    this.observer.observe(itemsWrapper);
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
    this.clearTimers();
  }

  private onVisibilityChange(isVisible: boolean): void {
    if (isVisible) {
      if (this.autoplayEnabled || this.autoplayTimeout) return;
      const delay = this.startInitial || this.startedBefore ? 300 : 7000;
      this.startedBefore = true;
      this.autoplayTimeout = setTimeout(() => {
        this.autoplayTimeout = null;
        this.autoplayEnabled = true;
        this.bizeGuvenenlerCarousel?.next();
        this.autoplayInterval = setInterval(() => {
          this.bizeGuvenenlerCarousel?.next();
        }, 4000);
      }, delay);
    } else {
      this.clearTimers();
      this.autoplayEnabled = false;
    }
  }

  private clearTimers(): void {
    if (this.autoplayTimeout) {
      clearTimeout(this.autoplayTimeout);
      this.autoplayTimeout = null;
    }
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
      this.autoplayInterval = null;
    }
  }
}
